import React from "react";
import ControlTower from "./ControlTower";

// Replaces the old single all-fleet FleetDashboard.jsx as the /dispatch
// index route. ControlTower.jsx now handles both roles internally (its own
// isAdmin() check branches the two sections -- Dispatcher Overview vs. "My
// Performance", Fleet Economics vs. "My Economics" -- that genuinely differ;
// everything else already reads from endpoints that auto-scope server-side
// by caller role), so this is a straight passthrough with no branch here.
// DispatcherHome.jsx is kept but no longer routed, same precedent as
// AdminFleetOverview.jsx from the earlier admin-only Control Tower build.
export default function DashboardHome() {
  return <ControlTower />;
}
